import { ComingSoon } from '@/components/shared/ComingSoon'
export function MarketingPage() { return <ComingSoon title="Marketing" description="AI-powered content studio, campaign management, and channel publishing." /> }
